import React, { useState, useEffect } from "react";
import Input from "../Common/Components/InputField";
import CustomSelect from "../Common/Components/Select";
import { useForm } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import ErrorMessage from "../Common/Components/ErrorMessage";
import ActionButton from "../Common/Components/Button";
import {
  createUser,
  getDccb,
  getDepartment,
  getState,
  getUserType,
  updateUserDetails,
} from "../apiSection/apiUrlConstent";
import service from "../apiSection/service";
import Loading from "../Common/Components/Loading";
import { ShowAlert } from "../Common/Components/Alert";
import MultipleSelectCheckmarks from "../Common/Components/MultipleSelectCheckmarks";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles(() => ({
  mainDiv: {
    padding: "15px",
    background: "white",
    color: "#2B3674",
    borderRadius: "8px",
  },
  subDiv: {
    background: "#F5F8FF",
    padding: "20px",
    marginTop: "10px",
    borderRadius: "8px",
  },
  labelRequired: {
    color: "red",
  },
  buttons: {
    float: "right",
    display: "flex",
    gap: "10px",
    marginTop: "30px",
  },
}));

export default function CreateUser(props) {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [userTypeData, setUserTypeData] = useState([]);
  const [dccbValues, setDccbValues] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [mulDcb, setMulDcb] = useState([]);
  const [selectedDccbCodes, setSelectedDccbCodes] = useState(() => {
    if (props?.user?.dccb_code && props?.user?.dccb_code?.length) {
      return [...props.user.dccb_code];
    } else {
      return [];
    }
  });
  const [selectedStateId, setSelectedStateId] = useState("");
  const [editAction, setEditAction] = useState(props?.action);

  useEffect(() => {
    if (props.action === "edit") {
      handleDccbData(props?.user?.state_id);
      setValue("firstName", props?.user?.FName);
      setValue("lastName", props?.user?.LName);
      setValue("pacNumber", props?.user?.pac_id);
      setValue("email", props?.user?.email);
      setValue("phonenumber", props?.user?.mobile);
      setValue("state", props?.user?.state_id);

      setValue("dccb", props?.user?.dccb_id);
      setValue("dccbM", props?.user?.dccb_code || []); // Default to an empty array if undefined
      setMulDcb(props?.user?.dccb_code || []);

      setValue("role", Number(props?.user?.role_id));
      setSelectedValue(Number(props?.user?.role_id));
    }
  }, [props.action, props.user]);

  useEffect(() => {
    if (props?.action === "edit") {
      handleDccbData(props?.user?.state_id);
    }
  }, []);

  const handleDepartment = () => {
    setLoading(true);
    service
      .get(getDepartment)
      .then((res) => {
        setLoading(false);
        setDepartmentData(res.data.result);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const handleUserType = () => {
    setLoading(true);
    service
      .get(getUserType)
      .then((res) => {
        setLoading(false);
        res.data.result.list_user_type[0].role_id = 4;
        setUserTypeData(res.data.result.list_user_type);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleStateData = () => {
    setLoading(true);
    service
      .get(getState)
      .then((res) => {
        setLoading(false);
        setStateData(res.data.result.list_state);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  function handleDccbData(data) {
    setSelectedStateId(data?.id ? data?.id : data);
    if (props?.action !== "edit") {
      setSelectedDccbCodes([]);
    }

    const postData = {
      state_name: data?.id ? data?.id : data,
    };
    if (data?.id || data) {
      setLoading(true);
      service
        .create(getDccb, postData)
        .then((res) => {
          setLoading(false);
          setDccbValues(res.data.result);
        })
        .catch((error) => {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: error.response.data.message,
            width: "400px",
          });
        });
    }
  }

  const handleSelectChange = (value) => {
    setEditAction("");
    setSelectedValue(value);
    if (value == 12 || value == 4) {
      setSelectedDccbCodes([]);
    }
    reset({
      dccbM: [],
      role: value,
    });
  };

  const handleCreateUser = (data) => {
    if (props.action === "edit") {
      const postData = {
        user_id: props?.user?.user_id,
        FName: data.firstName,
        LName: data.lastName,
        email: data.email || "",
        mobile: data.phonenumber ? String(data.phonenumber) : null,
        role_id: selectedValue,
        state_id: data.state,
        pac_id: "",
        erp_id: props?.user?.erp_id,
        dct_id: props?.user?.dct_id,
        dccb_id: 0,
        dccb_code: selectedDccbCodes,
      };

      setLoading(true);
      service
        .create(updateUserDetails, postData)
        .then((res) => {
          setLoading(false);

          ShowAlert({
            icon: "success",
            text: res?.data?.message,
          });
          props.setIsOpen(false);
          props.handleUserRefresh();
          props.handleRedenderTable();
        })
        .catch((error) => {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: error?.response?.data?.message,
            width: "400px",
          });
        });
    } else {
      const postData = {
        FName: data.firstName,
        LName: data.lastName,
        email: data.email,
        mobile: data.phonenumber,
        role_id: selectedValue,
        state_id: data.state,
        dccb_id: 0,
        dccb_code: selectedDccbCodes, // Multiple selection as an array of strings
        pac_id: "",
      };

      setLoading(true);
      service
        .create(createUser, postData)
        .then((res) => {
          setLoading(false);
          ShowAlert({
            icon: "success",
            text: res.data.message,
            width: "400px",
            confirmButtonText: "OK",
            confirmAction: () => {
              props.setTabIndex(0);
            },
          });
          reset({
            pacNumber: "",
            dccbM: "",
            firstName: "",
            lastName: "",
            email: "",
            role: "",
            phonenumber: "",
            state: "",
          });
        })
        .catch((error) => {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: error?.response?.data?.message,
            width: "400px",
          });
        });
    }
  };

  const handleCancel = () => {
    props.setTabIndex(0);
  };

  useEffect(() => {
    handleUserType();
    handleDepartment();
    handleStateData();
  }, []);

  return (
    <>
      <Loading open={loading} />
      <div className={classes.mainDiv}>
        {props.action === "edit" ? "Edit User" : "Create User"}
        <div className={classes.subDiv}>
          <div>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={3}
                md={3}
                lg={props.action == "edit" ? 5 : 3}
                xl={props.action == "edit" ? 5 : 3}
              >
                <Typography variant="body2" color="#2B3674">
                  User Type <span className={classes.labelRequired}>*</span>
                </Typography>
                <CustomSelect
                  name="role"
                  control={control}
                  defaultValue=""
                  listItems={userTypeData}
                  placeholder="Select"
                  displayValue="user_type"
                  keyValue="role_id"
                  height="45px"
                  width="100%"
                  disabled={props?.action === "edit" ? true : false}
                  required={true}
                  handleChange={(e) =>
                    handleSelectChange(Number(e.target.value))
                  }
                  inputRef={register("role", {
                    required: true,
                  })}
                />
                <div>
                  {errors.role && errors.role.type === "required" && (
                    <ErrorMessage message="Required !!" />
                  )}
                </div>
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={3}
                md={3}
                lg={props.action == "edit" ? 5 : 3}
                xl={props.action == "edit" ? 5 : 3}
                sx={{ marginTop: "10px" }}
              >
                <Input
                  type="text"
                  label="First Name"
                  name="firstName"
                  id="firstName"
                  borderRadius="8px"
                  backgroundColor="white"
                  color="#707EAE"
                  height="45px"
                  width="100%"
                  required={true}
                  inputRef={register("firstName", {
                    required: true,
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                />
                <div>
                  {errors.firstName && errors.firstName.type === "required" && (
                    <ErrorMessage message="Required !!" />
                  )}
                  {errors.firstName && errors.firstName.type === "pattern" && (
                    <ErrorMessage message={errors.firstName.message} />
                  )}
                </div>
              </Grid>
              <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5} xl={1.5}></Grid>
              <Grid
                item
                xs={12}
                sm={3}
                md={3}
                lg={props.action == "edit" ? 5 : 3}
                xl={props.action == "edit" ? 5 : 3}
              >
                <Input
                  type="text"
                  name="lastName"
                  label="Last Name"
                  id="lastName"
                  borderRadius="8px"
                  backgroundColor="white"
                  color="#707EAE"
                  height="45px"
                  width="100%"
                  inputRef={register("lastName", {
                    pattern: {
                      value: /^[A-Za-z]+$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                />
                <div>
                  {errors.lastName && errors.lastName.type === "required" && (
                    <ErrorMessage message="Required !!" />
                  )}
                  {errors.lastName && errors.lastName.type === "pattern" && (
                    <ErrorMessage message={errors.lastName.message} />
                  )}
                </div>
              </Grid>
              <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5} xl={1.5}></Grid>
            </Grid>
            <Grid container sx={{ marginTop: "10px" }}>
              <Grid
                item
                xs={12}
                sm={3}
                md={3}
                lg={props.action == "edit" ? 5 : 3}
                xl={props.action == "edit" ? 5 : 3}
              >
                <Input
                  type="text"
                  label="Email address"
                  name="email"
                  id="email"
                  borderRadius="8px"
                  backgroundColor="white"
                  color="#707EAE"
                  disabled={
                    props?.action === "edit" &&
                    [3, 4, 2, 8, 12, 14].includes(props?.user?.role_id)
                      ? true
                      : false
                  }
                  height="45px"
                  width="100%"
                  required={
                    editAction && editAction === "edit"
                      ? ![1].includes(props?.user?.role_id)
                      : !(selectedValue === 1)
                  }
                  inputRef={register("email", {
                    required:
                      editAction && editAction === "edit"
                        ? ![1].includes(props?.user?.role_id)
                        : !(selectedValue === 1),
                    pattern: {
                      value:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: "Invalid email address",
                    },
                  })}
                />
                <div>
                  {errors.email && errors.email.type === "required" && (
                    <ErrorMessage message="Required !!" />
                  )}
                  {errors.email && (
                    <ErrorMessage message={errors.email.message} />
                  )}
                </div>
              </Grid>
              <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5} xl={1.5}></Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={props.action == "edit" ? 5 : 3}
                xl={props.action == "edit" ? 5 : 3}
              >
                <Input
                  type="number"
                  label="Mobile Number"
                  control={control}
                  name="phonenumber"
                  id="phonenumber"
                  borderRadius="8px"
                  backgroundColor="white"
                  color="#707EAE"
                  height="45px"
                  width="100%"
                  // required={
                  // editAction && editAction === "edit"
                  //   ? ![1, 2, 8].includes(props?.user?.role_id)
                  //   : !(
                  //     selectedValue === 1 ||
                  //     selectedValue === 2 ||
                  //     selectedValue === 8
                  //   )
                  // false
                  // }
                  inputRef={register("phonenumber", {
                    maxLength: 10,
                    minLength: 10,
                    // required: {
                    // value:
                    //   editAction && editAction === "edit"
                    //     ? ![1, 2, 8].includes(props?.user?.role_id)
                    //     : !(
                    //       selectedValue === 1 ||
                    //       selectedValue === 2 ||
                    //       selectedValue === 8
                    //     ),
                    // message: "Required !!",
                    // },
                  })}
                />
                <div>
                  {/* {errors.phonenumber &&
                    errors.phonenumber.type === "required" && (
                      <ErrorMessage message={errors.phonenumber.message} />
                    )} */}
                  {errors.phonenumber &&
                    errors.phonenumber.type === "minLength" && (
                      <ErrorMessage message="Minimun length is 10" />
                    )}
                  {errors.phonenumber &&
                    errors.phonenumber.type === "maxLength" && (
                      <ErrorMessage message="Maximum Legth is 10" />
                    )}
                </div>
              </Grid>
              <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5} xl={1.5}></Grid>
            </Grid>
            <Grid container sx={{ marginTop: "10px" }}>
              <Grid
                item
                xs={12}
                sm={3}
                md={3}
                lg={props.action == "edit" ? 5 : 3}
                xl={props.action == "edit" ? 5 : 3}
              >
                <Typography variant="body2" color="#2B3674">
                  State <span className={classes.labelRequired}>*</span>
                </Typography>
                <CustomSelect
                  name="state"
                  control={control}
                  defaultValue=""
                  displayValue="label"
                  listItems={stateData.map((item) => ({
                    value: item.state_id,
                    label: item.state_name,
                  }))}
                  placeholder="Select"
                  keyValue="value"
                  height="45px"
                  width="100%"
                  disabled={props?.action === "edit" ? true : false}
                  required={true}
                  inputRef={register("state", {
                    required: true,
                  })}
                  handleChange={(e) => {
                    handleDccbData({ id: e.target.value });
                  }}
                />
                <div>
                  {errors.state && errors.state.type === "required" && (
                    <ErrorMessage message="Required !!" />
                  )}
                </div>
              </Grid>
              <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5} xl={1.5}></Grid>
              {(selectedValue === 12 || selectedValue === 4) && (
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={3}
                  lg={props.action == "edit" ? 5 : 3}
                  xl={props.action == "edit" ? 5 : 3}
                >
                  <Typography variant="body2" color="#2B3674">
                    DCCB{" "}
                    {!(
                      selectedValue === 2 ||
                      selectedValue === 8 ||
                      selectedValue === 3
                    ) && <span style={{ color: "red" }}>*</span>}
                  </Typography>
                  <MultipleSelectCheckmarks
                    list_items={dccbValues.map((item) => item.dccb_code)}
                    name="dccbN"
                    enableSearch={true}
                    rules={{ required: props.action == "edit" ? false : true }}
                    control={control}
                    preSelectedItems={[...selectedDccbCodes]}
                    onChangeHandler={(value) => {
                      setSelectedDccbCodes(value);
                    }}
                    disableMultiple={selectedValue === 12 ? true : false} // Disable multiple if "12" is selected
                  />
                  <div>
                    {errors.dccbN && <ErrorMessage message="Required !!" />}
                  </div>
                </Grid>
              )}
            </Grid>

            <div className={classes.buttons}>
              <div>
                <ActionButton
                  variant="text"
                  padding="10px 25px"
                  borderRadius="8px"
                  backgroundColor="white"
                  border="1px solid #0FA5D9"
                  color="#0FA5D9"
                  buttonText="Cancel"
                  handleSubmit={() => {
                    props.action === "edit"
                      ? props.setIsOpen(false)
                      : handleCancel();
                  }}
                />
              </div>
              <div>
                <ActionButton
                  variant="text"
                  padding="10px 15px"
                  borderRadius="8px"
                  backgroundColor="#0FA5D9"
                  color="white"
                  buttonText={
                    props.action === "edit" ? "Edit User" : "Create User"
                  }
                  handleSubmit={handleSubmit(handleCreateUser)}
                  disabled={!isValid}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
